<template lang="pug">
  v-container
    v-subheader Campagne d'annonce
    v-row
      v-col
        v-list
          v-list-item
            v-list-item-content Nom :
            strong {{ routeStateAddSetup.name }}
          v-list-item
            v-list-item-content Type :
            strong {{ routeStateAddSetup.type }}
          v-list-item(v-if="routeStateAddSetup.file")
            v-list-item-content Durée :
            strong {{ routeStateAddSetup.file.duration || 10 }}s
          v-list-item
            v-list-item-content Visionnages :
            strong {{ routeStateAddSetup.viewsCountTotal }}
          v-list-item
            v-list-item-content Prix :
            strong {{ $money(routeStateAddSetup.price) }}
    v-row
      v-col(:cols="12")
        v-text-field(
          ref='cardNumber'
          v-bind="stripe.cardNumber"
          placeholder="#### #### #### ####"
          filled
          label="Numéro de la carte")
      v-col(:cols="6")
        v-text-field(
          ref="cardExpiry"
          v-bind="stripe.cardExpiry"
          placeholder="mm / aa"
          filled
          label="Date d'expiration")
      v-col(:cols="6")
        v-text-field(
          ref="cardCvc"
          v-bind="stripe.cardCvc"
          placeholder="###"
          filled
          label="CVC")
</template>

<script>
import router from '@iez/core/router'
import { toRefs, reactive } from '@vue/composition-api'
import { injectRouteState, page } from '@iez/core'
import useStripe from '@iez/lib/use-stripe/'
import createRefs from '@iez/lib/create-refs/'
import createOnClick from '@iez/lib/create-on-click/'
import waitFor from '@iez/lib/wait-for/'

const route = {
  name: `AddPayment`,
  path: `/add-payment/`
}

export default {
  ...route,

  setup () {
    const routeStateAddSetup = injectRouteState({
      name: `AddSetup`
    })

    const routeState = injectRouteState({
      payload: {
        paymentId: null
      }
    })

    const stripeRefs = createRefs([
      'cardNumber',
      'cardExpiry',
      'cardCvc'
    ])

    page.topBar.set({
      title: `Paiement sécurisé`
    })

    const stripe = useStripe({
      objs: stripeRefs,
      purchase: routeStateAddSetup.price
    })

    page.blockingProgression.set(
      () => !stripe.state.clientSecret
        ? {
          isActive: true
        } : null
    )

    waitFor({
      dependencies: () => stripe.state.clientSecret
    }).then(result => {
      if (result.error) {
        router.back()
      }
    })

    const state = reactive({
      stripe: stripe.state
    })

    page.bottomAction.set(
      () =>
        state.stripe.complete
          ? ({
            action: {
              label: `Payer`,
              onClick: createOnClick({
                pay: async () => {
                  const { paymentId, error } = await stripe.pay()
                  if (error) {
                    page.blockingDialog.set({
                      title: `Paiement refusé`,
                      content: error,
                      action1: {
                        label: `Fermer`,
                        onClick: () => {
                          page.blockingDialog.unset()
                        }
                      },
                      action2: null
                    })
                  } else {
                    routeState.paymentId = paymentId
                    router.replace({
                      name: 'AddUploading'
                    })
                  }
                }
              })
            }
          }) : null
    )

    return {
      routeStateAddSetup,
      ...stripeRefs,
      ...toRefs(state)
    }
  }
}
</script>
